module.exports = __webpack_public_path__ + "img/ic-stripe.e08ea5eb.svg";